var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessageInputBoxAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 19,
    viewBox: "0 0 12 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414042",
    d: "M5.963 26.5A5.97 5.97 0 010 20.538v-15.9A4.643 4.643 0 014.638 0a4.643 4.643 0 014.637 4.638v14.575a3.316 3.316 0 01-3.313 3.312 3.316 3.316 0 01-3.312-3.313v-7.95a.663.663 0 011.325 0v7.95A1.99 1.99 0 005.963 21.2a1.99 1.99 0 001.987-1.988V4.637a3.316 3.316 0 00-3.313-3.312 3.316 3.316 0 00-3.312 3.313v15.9a4.643 4.643 0 004.638 4.637 4.643 4.643 0 004.637-4.637v-9.276a.663.663 0 011.325 0v9.276A5.97 5.97 0 015.962 26.5z"
  })));
}

export default SvgMessageInputBoxAttach;